import React from 'react';
import { useTranslation } from 'react-i18next';
import { QRCodeSVG } from 'qrcode.react';
import { amountInWords } from '../utils/numberToWords';

export default function DonationReceipt({ donation, settings }) {
  const { t } = useTranslation();
  const PURPOSE_LABELS = {
    general: t('receipt.purposeGeneral'),
    cow_adoption: t('receipt.purposeCowAdoption'),
    fodder: t('receipt.purposeFodder'),
    medical: t('receipt.purposeMedical'),
    infrastructure: t('receipt.purposeInfrastructure'),
    festival: t('receipt.purposeFestival'),
  };
  const purposeLabel = PURPOSE_LABELS[donation.purpose] || t('receipt.purposeDefault');
  const receiptUrl = `${window.location.origin}/donation/receipt/${donation.txnId}`;
  const date = donation.createdAt ? new Date(donation.createdAt) : new Date();

  return (
    <div className="receipt-card">
      <div className="receipt-header">
        <div className="receipt-header-text">
          <div className="receipt-org-name">{settings.siteName || 'Goshala'}</div>
          {settings.trustName && <div className="receipt-trust-name">{settings.trustName}</div>}
          {settings.address && <div className="receipt-org-line">{settings.address}</div>}
          <div className="receipt-org-line">
            {[settings.contactPhone && `Ph: ${settings.contactPhone}`, settings.contactEmail, settings.websiteUrl]
              .filter(Boolean).join('  |  ')}
          </div>
        </div>
        <div className="receipt-qr">
          <QRCodeSVG value={receiptUrl} size={78} fgColor="#211208" level="M" />
        </div>
      </div>

      <div className="receipt-title">{t('receipt.title')}</div>

      <div className="receipt-meta-row">
        <div><span className="receipt-label">{t('receipt.receiptNo')}</span> {donation.receiptNumber || '—'}</div>
        <div><span className="receipt-label">{t('receipt.date')}</span> {date.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}</div>
      </div>

      <div className="receipt-field">
        <span className="receipt-label">{t('receipt.receivedFrom')}</span>
        <span className="receipt-field-value">{donation.isAnonymous ? t('receipt.anonymousDonor') : (donation.donorName || '—')}</span>
      </div>
      <div className="receipt-field">
        <span className="receipt-label">{t('receipt.address')}</span>
        <span className="receipt-field-value">{donation.donorAddress || ''}</span>
      </div>
      <div className="receipt-meta-row">
        <div className="receipt-field" style={{ flex: 1 }}><span className="receipt-label">{t('receipt.phone')}</span> <span className="receipt-field-value">{donation.donorMobile || ''}</span></div>
        <div className="receipt-field" style={{ flex: 1 }}><span className="receipt-label">{t('receipt.email')}</span> <span className="receipt-field-value">{donation.donorEmail || ''}</span></div>
      </div>

      <div className="receipt-amount-box">
        <div className="receipt-amount-figures">₹ {Number(donation.amount || 0).toLocaleString('en-IN')}</div>
        <div className="receipt-amount-words">{amountInWords(donation.amount)}</div>
      </div>

      <div className="receipt-field">
        {t('receipt.receivedTowards')} <strong>{purposeLabel}</strong>.
      </div>
      <div className="receipt-field receipt-field-sub">
        {t('receipt.paymentMode')} &nbsp;|&nbsp; {t('receipt.transactionId')} {donation.txnId}
      </div>

      {(settings.trustPanNo || settings.section80GNo) && (
        <div className="receipt-pan-row">
          {settings.trustPanNo && <div><span className="receipt-label">{t('receipt.panNo')}</span> {settings.trustPanNo}</div>}
          {settings.section80GNo && <div><span className="receipt-label">{t('receipt.for80G')}</span> {settings.section80GNo}</div>}
        </div>
      )}

      {(settings.bankName || settings.bankAccount) && (
        <div className="receipt-bank-box">
          <div className="receipt-bank-title">{t('receipt.bankAccountDetails')}</div>
          {settings.bankName && <div>{t('receipt.bank')} {settings.bankName}</div>}
          {settings.bankAccount && <div>{t('receipt.accountNo')} {settings.bankAccount}</div>}
          {settings.bankBranch && <div>{t('receipt.branch')} {settings.bankBranch}</div>}
          {settings.bankIFSC && <div>{t('receipt.ifsc')} {settings.bankIFSC}</div>}
        </div>
      )}

      <div className="receipt-footer-note">
        {t('receipt.footerNote', { trust: settings.trustName || settings.siteName })}
      </div>

      <div className="receipt-sign-row">
        <div>{t('receipt.forTrust', { trust: settings.trustName || settings.siteName })}</div>
        <div>{t('receipt.authorizedSignatory')}</div>
      </div>
    </div>
  );
}
